import React from "react";
import "./Features.css";
import Card from "../Card/Card";
import niche from "../../img/1.png";
import essence from "../../img/2.png";
import forum from "../../img/3.png";
import market from "../../img/4.png";
import { motion } from "framer-motion";

const transition = { duration: 1, type: "spring" };

const Features = () => {
  return (
    <div className="features" id="Features">
      {/* Left Side */}
      <div className="awesome">
        <span>Features</span>
        <span>Hobbestie is not just another community platform</span>
        <spane>
          Hobbestie helps you find like-minded individuals
          <br />
          It’s a revolution in how people connect through shared passions.
          <br />
          Whether you love photography, gaming, music, art, or any niche hobby
          <br />
          build meaningful friendships, and showcase your creativity like never
          before.
        </spane>

        <div className="blur s-blur1"></div>
      </div>

      {/* Right Side */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "22rem" }}
          transition={transition}
          style={{ left: "24rem" }}
        >
          <Card
            emoji={niche}
            heading={"Endless Niche Hobbies"}
            detail={
              "Explore and connect with enthusiasts from a variety of hobby communities."
            }
          />
        </motion.div>

        {/* second card */}
        <motion.div
          initial={{ left: "10%" }}
          whileInView={{ left: "5rem" }}
          transition={transition}
          style={{ top: "9rem", left: "1rem" }}
        >
          <Card
            emoji={forum}
            heading={"Forum & Channels"}
            detail={
              "Join discussions of hobbies with topic-based channels and create threaded conversations."
            }
          />
        </motion.div>

        {/* third card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "22rem" }}
          transition={transition}
          style={{ top: "22rem", left: "24rem" }}
        >
          <Card
            emoji={essence}
            heading={"Social Media Essence"}
            detail={
              "Engage with content through likes, comments, and shares while growing your network."
            }
          />
        </motion.div>

        {/* fourth card */}
        <motion.div
          initial={{ left: "10%" }}
          whileInView={{ left: "5rem" }}
          transition={transition}
          style={{ top: "31rem", left: "1rem" }}
        >
          <Card
            emoji={market}
            heading={"Digital Marketplace"}
            detail={
              "Sell and purchase digital products related to hobbies, from art prints to tutorials."
            }
          />
        </motion.div>

        <div className="blur s-blur2"></div>
      </div>
    </div>
  );
};
export default Features;
